import { render, staticRenderFns } from "./SolutionAccess.vue?vue&type=template&id=7512cfe5&scoped=true&"
import script from "./SolutionAccess.vue?vue&type=script&lang=ts&"
export * from "./SolutionAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512cfe5",
  null
  
)

export default component.exports